(() => {
  const log = (...args) => console.debug("[cb-cds-packages]", ...args);

  const PAGE_PATH = "/pages/custom-design-service";
  const PRODUCT_HANDLE = "custom-design-service";
  const BUTTON_TEXT_TO_PACKAGE = {
    "Add Standard to Cart": "Standard",
    "Add Pro to Cart": "Pro",
  };

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn, { once: true });
  }

  function onCdsPage() {
    return window.location && window.location.pathname === PAGE_PATH;
  }

  async function fetchProductJson() {
    const url = `/products/${PRODUCT_HANDLE}.js`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Failed to fetch ${url} (${res.status})`);
    return await res.json();
  }

  function findVariantIdForPackage(product, pkgValue) {
    // Shopify product .js typically includes:
    // product.options: ["Package", ...]
    // product.variants[].options: ["Standard", ...] OR option1/option2/option3
    const options = Array.isArray(product.options) ? product.options : [];
    const pkgIndex = options.findIndex(
      (o) => String(o).trim().toLowerCase() === "package"
    );

    const variants = Array.isArray(product.variants) ? product.variants : [];
    for (const v of variants) {
      const opts =
        Array.isArray(v.options) && v.options.length
          ? v.options
          : [v.option1, v.option2, v.option3].filter(Boolean);

      if (pkgIndex >= 0) {
        if (opts[pkgIndex] === pkgValue) return v.id;
      } else {
        if (opts.includes(pkgValue)) return v.id;
      }
    }
    return null;
  }

  async function addVariantToCart(variantId) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
      }),
    });

    // Shopify returns JSON even on errors, but not always. Guard it.
    let data = null;
    try {
      data = await res.json();
    } catch (_) {}

    if (!res.ok) {
      const msg =
        (data && (data.description || data.message)) ||
        `Add to cart failed (${res.status})`;
      throw new Error(msg);
    }
    return data;
  }

  function setBusy(el, busy) {
    if (!el) return;
    el.__cbBusy = !!busy;
    el.style.pointerEvents = busy ? "none" : "";
    el.style.opacity = busy ? "0.7" : "";
    el.style.cursor = busy ? "wait" : "";
  }

  function normalizeText(el) {
    return (el.textContent || "").replace(/\s+/g, " ").trim();
  }

  ready(() => {
    if (!onCdsPage()) return;

    log("init");

    // Capture clicks anywhere on the page and match by visible button text.
    document.addEventListener("click", async (e) => {
      const target = e.target.closest("button, a, [role='button']");
      if (!target) return;

const label = normalizeText(target);

// 1) Get Catalog -> scroll to Shopify form
if (/get\s+catalog/i.test(label)) {
  e.preventDefault();
  e.stopPropagation();

  const formWrap = document.querySelector('[data-forms-id="forms-root-888556"]');

  if (formWrap) {
    const y = formWrap.getBoundingClientRect().top + window.pageYOffset - 120;

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });

    const emailInput = formWrap.querySelector('input[type="email"]');
    if (emailInput) {
      setTimeout(() => emailInput.focus(), 350);
    }
  } else {
    console.warn("[cb-cds-packages] Shopify form block not found");
  }

  return;
}

// 2) Add-to-cart buttons
const pkgValue = BUTTON_TEXT_TO_PACKAGE[label];
if (!pkgValue) return;


      // Prevent navigation or form submits if the theme wrapped it oddly
      e.preventDefault();
      e.stopPropagation();

      if (target.__cbBusy) return;

      try {
        setBusy(target, true);
        log("clicked:", label, "=>", pkgValue);

        const product = await fetchProductJson();
        const variantId = findVariantIdForPackage(product, pkgValue);

        if (!variantId) {
          throw new Error(
            `Could not find variant for Package = "${pkgValue}" on product "${PRODUCT_HANDLE}".`
          );
        }

        await addVariantToCart(variantId);
        log("added to cart:", variantId);

        // Theme-dependent: if a cart drawer exists, trigger it; otherwise go to cart.
        // Try common patterns; fall back to redirect.
        const opened =
          (window.theme &&
            window.theme.cartDrawer &&
            typeof window.theme.cartDrawer.open === "function" &&
            (window.theme.cartDrawer.open(), true)) ||
          (window.CartDrawer &&
            typeof window.CartDrawer.open === "function" &&
            (window.CartDrawer.open(), true)) ||
          false;

        if (!opened) window.location.href = "/cart";
      } catch (err) {
        console.error("[cb-cds-packages] error:", err);
        alert(err.message || "Sorry, something went wrong adding that to the cart.");
      } finally {
        setBusy(target, false);
      }
    });
  });
})();
